import React, { useState } from 'react';
import { Formik, Field, Form } from 'formik';
import Modal from 'react-modal';
import apiClient from '../../utils/apiClient';

Modal.setAppElement('#root');



function OTPModal({ modalIsOpen, setModalIsOpen, setIsEmailVerified, parentValues }) {
    const [otpError, setOtpError] = useState("")

    return (
      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          className="m-auto p-2 bg-white w-1/3 w-screen h-screen flex flex-col justify-center items-center">
          <h1 className="mb-4 text-xl font-extrabold tracking-tight leading-none text-gray-900 md:text-xl lg:text-xl dark:text-white mb-24">
            Please verify your email
          </h1>
          <Formik
            initialValues={{
              emailOTP: "",
            }}
            onSubmit={(values) => {
              const data = {
                email_id: parentValues.email,
                name: parentValues.name,
                email_otp: values.emailOTP,
                phone_number: parentValues.countryCode + parentValues.phone,
              };

              apiClient()
                .post("user/create-entry/", data)
                .then((response) => {
                  if (response?.data?.data?.data?.entry_valid) {
                    setIsEmailVerified(true);
                    setModalIsOpen(false);
                  } else {
                    setOtpError("Invalid OTP");
                  }
                })
                .catch((error) => console.error("Error:", error));
            }}>
            <Form className="space-y-4 border border-black mx-4 sm:w-[25rem] rounded-lg px-20 py-10">
              {/*<div>
                            <label htmlFor="mobileOTP" className="block text-sm font-medium text-gray-700">
                                Mobile OTP
                            </label>
                            <Field
                                id="mobileOTP"
                                name="mobileOTP"
                                type="text"
                                className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                        </div>*/}
              <div>
                <label
                  htmlFor="emailOTP"
                  className="block text-sm font-medium text-gray-700">
                  Email OTP
                </label>
                <Field
                  id="emailOTP"
                  name="emailOTP"
                  type="text"
                  className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 text-xl font-semibold"
                />
              </div>
              {otpError && <div className="text-red-500">{otpError}</div>}
              <button
                type="submit"
                className="border-[1px] bg-black rounded text-white px-5 py-[6px] border-black w-full">
                Verify
              </button>
            </Form>
          </Formik>
        </Modal>
      </div>
    );
}

export default OTPModal;